import React from 'react';
import {ChangePasswordForm} from './form';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {ChangePasswordMobile} from './mobile';

export const ProfileChangePassword: React.FC<{onFormSubmitted?: () => void}> = ({onFormSubmitted}) => {
  const deviceSize = useDeviceSize();
  return deviceSize === DeviceSize.desktop ? (
    <ChangePasswordForm onFormSubmitted={onFormSubmitted} />
  ) : (
    <ChangePasswordMobile />
  );
};
